<template>
  <div>
    <!-- <van-nav-bar
      :title="$route.meta.title"
      left-text="返回"
      @click-left="$router.back()"
      left-arrow
      :fixed="true"
    /> -->
    <div class="evaluation-explain-counter">
      <div class="explain-counter">
        <van-icon
          name="checked"
          size="80"
          color="#0cb327"
          v-if="$route.query.type == 'success'"
        />
        <van-icon name="warning" size="80" color="#ff8e20" v-else />
        <div class="survey-status" v-show="$route.query.type == 'success'">
          {{ $t('explainSuccessTips') }}
        </div>
        <div class="survey-status">
          {{
            $route.query.type == "noStart"
              ? $t('noStartStatusTips')
              : $route.query.type == "stop"
              ? $t('stopStatusTips')
              : $route.query.type == "error"
              ? $t('errorStatusTips')
              : ""
          }}
        </div>
        <div class="survey-explain" v-show="$route.query.type == 'success'">
          {{ $t('surveySuccessTips') }}
        </div>
        <div class="survey-explain">
          {{
            $route.query.type == "noStart"
              ? $t('noStartSurveyTips')
              : $route.query.type == "stop"
              ? $t('stopSurveyTips')
              : $route.query.type == "error"
              ? $t('errorSurveyTips')
              : ""
          }}
        </div>
        <van-button
          type="primary"
          style="margin-top: 25px"
          size="large"
          @click="$router.back()"
          >{{ $t('confirm') }}</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.evaluation-explain-counter {
  padding: 12px;
  box-sizing: border-box;
  height: 100vh;
  // margin-top: 45px;
  text-align: center;
  .explain-counter {
    margin-top: 100px;
    .survey-status {
      font-size: 18px;
      margin-top: 30px;
    }
    .survey-explain {
      font-size: 15px;
      color: #666;
      margin-top: 10px;
    }
  }
}
</style>
